import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import Icons from "../../../../resources/icons/Icons";
import classes from "../CustomInputs.module.css";
import CustomTooltip  from "../../Tooltip/CustomTooltip/CustomTooltip";

const PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (props.handleError) {
      props.handleError({[props.id]: props.hasError});
    }
  }, [props.value]);

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    props.onChange({[name]: value });
  };

  return (
    <div className={classes.customTextField}>
      <TextField
        fullWidth
        label={props.label}
        id={props.id}
        name={props.id}
        type={showPassword ? "text" : "password"}
        className={classes.textField}
        defaultValue={props.value}
        onChange={handleChange}
        error={props.isStepSubmitted && props.hasError}
        helperText={
          props.isStepSubmitted && props.hasError ? props.errorMessage : ""
        }
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
              
              {props.showTooltip && 
              <CustomTooltip 
                {...props}>
              </CustomTooltip>}
            </InputAdornment>
          ),
          classes: {
            notchedOutline: classes.filed,
          },
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
        />
        {/* {props.showTooltip && (
            <CustomTooltip {...props} isOutOfField={true}></CustomTooltip>
          )} */}
    </div>
  );
};

export default PasswordInput;
